import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { CHAPTERS } from "../../lib/content";
import { Eyebrow } from "../Reveal";

const Chapter = ({ c, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);
  const flipped = i % 2 === 1;

  return (
    <div
      ref={ref}
      className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center py-16 md:py-24 ${
        flipped ? "md:[direction:rtl]" : ""
      }`}
    >
      <div className="overflow-hidden border border-border md:[direction:ltr]">
        <motion.img
          style={{ scale: imgScale }}
          src={c.img}
          alt={c.title}
          className="w-full h-[340px] md:h-[560px] object-cover"
        />
      </div>

      <div className="md:[direction:ltr]">
        <motion.span
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="font-display text-primary/25 text-[7rem] md:text-[11rem] font-light leading-[0.7] block mb-2"
        >
          {c.n}
        </motion.span>
        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-display text-4xl md:text-6xl font-light tracking-tight leading-none mb-6"
        >
          {c.title}
        </motion.h3>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="text-muted-foreground text-base md:text-lg font-light leading-relaxed max-w-md"
        >
          {c.copy}
        </motion.p>
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section id="why" data-testid="manifesto" className="bg-background py-20 md:py-28">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-4">
        <Eyebrow>Why Rest Assured</Eyebrow>
        <h2 className="font-display text-5xl md:text-7xl font-light tracking-tight leading-[0.95] mt-4">
          The name is
          <span className="text-primary italic"> the promise.</span>
        </h2>
      </div>
      {CHAPTERS.map((c, i) => (
        <Chapter key={c.n} c={c} i={i} />
      ))}
    </div>
  </section>
);
